import {
    useQuery,
} from "react-query"
import httpClient from "./httpClient"

export const useGetTokenDetails = (token, tenant_id) => useQuery(['tokens', token, tenant_id], async () => {
    const response = await httpClient.get(`/tokens/${tenant_id}/${token}`)
    return response.data
})